import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {ApiEvsService} from 'app/common/services/ApiEvs.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Headers, Http} from '@angular/http';
import {Subject} from 'rxjs';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable(

)
export class BusinessContactService {
  headers: Headers;
  url = environment.qrcode_url;
  url_qrcode_aps = environment.qrcode_url_aps;
  profileBussinessUpdate$ = new BehaviorSubject(null);

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem('Access-Token');
    console.log('vao day kookok?????ok1111', token)
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    console.log('vao day kookok?????ok', this.headers)
    // this.profileImageUpdate$.subscribe((profileImage) => {
    //   console.log("============ ", profileImage)
    // });

  }

  getBusinessContact(): Observable<any> {
    const token = localStorage.getItem('Access-Token');
    // thí
    return this.http
      .get(`${this.url_qrcode_aps}/account/contact`, {
        headers: this.headers,
      })
      .map((res: any) => res.json())
      .catch((err: any) => {
        throw this.apiEvsService.checkErr(err);
      });
  }

  updateBusinessContact(body?: any): Observable<any> {
    return this.http
      .put(`${this.url_qrcode_aps}/account/contact`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/business-contact/services/business-contact.service.ts